(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["study-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const track = document.getElementById('sliderTrack');
  const container = document.getElementById('sliderContainer');
  let cards = Array.from(track.children);
  const cloneCount = cards.length;

  let isTransitioning = false;

  function cloneSlides() {
    // Clone all cards for the end
    cards.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('clone');
      track.appendChild(clone);
    });

    // Clone all cards for the beginning (in reverse)
    [...cards].reverse().forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('clone');
      track.insertBefore(clone, track.firstChild);
    });

    // Update cards reference
    cards = Array.from(track.children);
  }

  cloneSlides();

  let currentIndex = cloneCount; // Start at the first original slide
  let cardWidth = cards[0].offsetWidth + 24;

  function updateSlider(transition = true) {
    if (transition) {
      track.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
    } else {
      track.style.transition = 'none';
    }
    track.style.transform = `translateX(-${cardWidth * currentIndex}px)`;
  }

  window.moveToNext = function () {
    if (isTransitioning) return;
    isTransitioning = true;

    currentIndex++;
    updateSlider(true);

    track.addEventListener('transitionend', () => {
      if (currentIndex >= cards.length - cloneCount) {
        currentIndex = cloneCount;
        updateSlider(false);
      }
      isTransitioning = false;
    }, { once: true });
  };

  window.moveToPrev = function () {
    if (isTransitioning) return;
    isTransitioning = true;

    currentIndex--;
    updateSlider(true);

    track.addEventListener('transitionend', () => {
      if (currentIndex < cloneCount) {
        currentIndex = cards.length - cloneCount - 1;
        updateSlider(false);
      }
      isTransitioning = false;
    }, { once: true });
  };

  // Drag/Swipe
  let isDragging = false;
  let startX = 0;

  container.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
  });

  container.addEventListener('mouseup', () => isDragging = false);
  container.addEventListener('mouseleave', () => isDragging = false);
  container.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const x = e.pageX;
    const walk = x - startX;
    if (Math.abs(walk) > 50) {
      walk < 0 ? moveToNext() : moveToPrev();
      isDragging = false;
    }
  });

  container.addEventListener('touchstart', (e) => {
    isDragging = true;
    startX = e.touches[0].clientX;
  });

  container.addEventListener('touchend', () => isDragging = false);
  container.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const x = e.touches[0].clientX;
    const walk = x - startX;
    if (Math.abs(walk) > 50) {
      walk < 0 ? moveToNext() : moveToPrev();
      isDragging = false;
    }
  });

  window.addEventListener('resize', () => {
    cardWidth = cards[0].offsetWidth + 24;
    updateSlider(false);
  });

  window.addEventListener('load', () => {
    cardWidth = cards[0].offsetWidth + 24;
    updateSlider(false);
  });
});

  } catch(e) { console.error(e); }
})();
})();
